import { Subscription } from 'rxjs/Rx';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ModalService } from './modal.service';

interface ModalContent {
  visible:boolean;
  visibleAnimate?: boolean;
  titulo?: string;
  descricao?:string;
  tipo?:string; 
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {

  public visible = false;
  public visibleAnimate = false;
  private subscription: Subscription;

  titulo: string;
  descricao: string;
  tipo: string; 
  labelOk: string;
  labelCancelar: string;

  constructor(private _modalService: ModalService){
    this.subscription = _modalService.status$.subscribe(
      (status) => {
        this.visible = status.visible;
        setTimeout(() => this.visibleAnimate = status.visibleAnimate, 100);
        this.titulo = status.titulo ? status.titulo: "" ;
        this.descricao = status.descricao ? status.descricao : status.descricao;
        this.tipo = status.tipo ? status.tipo : "default";
        this.labelOk = status.labelOk ? status.labelOk : "Ok";
        this.labelCancelar = status.labelCancelar ? status.labelCancelar : "Cancelar";
    });
  }

  ngOnInit(){}

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  emitirEvento(evento) {
    this.visible = false;
    this.visibleAnimate = false;
    this.tipo = "";
    this.titulo = "";
    this.descricao = "";
    this._modalService.emitirEvento(evento);
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/modal/modal.component.ts